import type { JSX } from 'react';
import { SortableTableHead } from './SortableTableHead';
import type { SortState } from '@/shared/types/table-filters.types';

export interface SortableHeaderDef {
  key: string;
  label: string;
  className?: string;
}

export interface SortableTableHeadersProps {
  headers: SortableHeaderDef[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
}

/** The sortable part of a table header row; static headers are rendered by the caller. */
export function SortableTableHeaders({
  headers,
  sort,
  onToggleSort,
}: SortableTableHeadersProps): JSX.Element {
  return (
    <>
      {headers.map((header) => (
        <SortableTableHead
          key={header.key}
          columnKey={header.key}
          label={header.label}
          className={header.className}
          sort={sort}
          onToggleSort={onToggleSort}
        />
      ))}
    </>
  );
}
